import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@commenda/kakashi';

interface UploadSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  corporationName?: string;
  fiscalYear: number;
  onViewDocuments: () => void;
}

export const UploadSuccessModal = ({
  isOpen,
  onClose,
  corporationName,
  fiscalYear,
  onViewDocuments,
}: UploadSuccessModalProps) => {
  const breadcrumb = `${corporationName ?? 'This entity'} > Financial Documents > FY ${fiscalYear} > Cap table`;
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[560px]">
        <DialogHeader>
          <DialogTitle>Documents uploaded</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col gap-2xl p-3xl">
          <p className="txt-small-regular text-text-primary">
            Your ownership documents have been uploaded successfully.
          </p>
          <div className="flex flex-col gap-md">
            <p className="txt-small-regular text-text-primary">
              They are now available in:
            </p>
            <p className="txt-small-bold text-text-primary">{breadcrumb}</p>
          </div>
        </div>
        <DialogFooter>
          <Button variant="secondary" size="md" onClick={onClose}>
            Close
          </Button>
          <Button variant="primary" size="md" onClick={onViewDocuments}>
            View documents
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
